export default __webpack_public_path__ + "static/media/Lora-SemiBoldItalic.51f4591b.ttf";